var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon example "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0003 11.406C11.4739 11.406 11.8826 11.2341 12.2263 10.8904C12.5701 10.5466 12.7419 10.1379 12.7419 9.66432C12.7419 9.19071 12.5701 8.78203 12.2263 8.43828C11.8826 8.09453 11.4739 7.92266 11.0003 7.92266C10.5266 7.92266 10.118 8.09453 9.77422 8.43828C9.43047 8.78203 9.25859 9.19071 9.25859 9.66432C9.25859 10.1379 9.43047 10.5466 9.77422 10.8904C10.118 11.2341 10.5266 11.406 11.0003 11.406ZM11.0003 18.3268C12.8947 16.5852 14.2964 15.0039 15.2055 13.5831C16.1145 12.1622 16.569 10.9171 16.569 9.84766C16.569 8.1671 16.0305 6.78828 14.9534 5.7112C13.8763 4.63412 12.5586 4.09557 11.0003 4.09557C9.44193 4.09557 8.12422 4.63412 7.04714 5.7112C5.97005 6.78828 5.43151 8.1671 5.43151 9.84766C5.43151 10.9171 5.89748 12.1584 6.82943 13.5716C7.76137 14.9848 9.15165 16.5699 11.0003 18.3268ZM11.0003 21.1685C8.41832 18.9685 6.48568 16.9289 5.20234 15.0497C3.91901 13.1706 3.27734 11.4365 3.27734 9.84766C3.27734 7.43377 4.05269 5.51259 5.60339 4.08411C7.15408 2.65564 8.95304 1.94141 11.0003 1.94141C13.0475 1.94141 14.8464 2.65564 16.3971 4.08411C17.9478 5.51259 18.7232 7.43377 18.7232 9.84766C18.7232 11.4365 18.0815 13.1706 16.7982 15.0497C15.5148 16.9289 13.5822 18.9685 11.0003 21.1685Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconBl);
export default __webpack_public_path__ + "static/media/location-icon-bl.b874f047bad475181d3eff1bf03977a8.svg";
export { ForwardRef as ReactComponent };